import React from 'react'
import cx from 'classnames'

import s from './PageContainer.scss'


type PageContainerProps = {
  id?: string
  className?: string
  withTopPadding?: boolean
}

const PageContainer: React.FunctionComponent<PageContainerProps> = (props) => {
  const { children, id, className, withTopPadding } = props

  const rootClassName = cx(s.pageContainer, className, {
    [s.withTopPadding]: withTopPadding,
  })

  return (
    <div className={rootClassName} id={id}>
      <div className={s.pageContainerIn}>
        {children}
      </div>
    </div>
  )
}


export default PageContainer
